"use client";

import * as React from "react";
import { OfficialMonitorTab } from "@/app/dashboard/admin/institutions/[id]/official-monitor/OfficialMonitorTab";
export default function Page({
  institutionId
}: {
  institutionId: string;
}) {
  return <div data-sentry-component="Page" data-sentry-source-file="page.client.tsx">
      <OfficialMonitorTab institutionId={institutionId} isPublicView data-sentry-element="OfficialMonitorTab" data-sentry-source-file="page.client.tsx" />
    </div>;
}